module.exports = __webpack_public_path__ + "static/media/nlu_ibm.ba10483f.png";